module.exports = __webpack_public_path__ + "img/stock6.3f559d69.png";